// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__sm6em"};